import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationInvoiceIcon from '../../assets/notification-invoice.svg';
import NotificationProjectIcon from '../../assets/notification-project.svg';
import { DashboardSummary } from '../../models/dashboardSummary';
import { INVOICES, PROJECTS } from '../../router/constants';

interface Props {
  name: string;
  iconSrc: string;
  onNotificationClick: () => void;
  children?: React.ReactNode;
}

const NotificationCard = (props: Props): JSX.Element => {
  return (
    <Paper
      sx={{ flex: '1 1 0px', height: '150px', p: 3, cursor: 'pointer' }}
      onClick={props.onNotificationClick}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography color="primary" variant="h6">
          {props.name}
        </Typography>
        <img src={props.iconSrc} alt="icon" />
      </Box>
      {props.children}
    </Paper>
  );
};

const NotificationsList = ({
  notification
}: {
  notification: DashboardSummary;
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 3,
        mb: 4
      }}
    >
      <NotificationCard
        name="PROJECTS"
        iconSrc={NotificationProjectIcon}
        onNotificationClick={() =>
          navigate(PROJECTS, { state: { notification: 1 } })
        }
      >
        <Typography color="grey.900" fontWeight="bold">
          {notification.declinedProjects} Projects have been declined
        </Typography>
        <Typography color="grey.900" fontWeight="bold">
          {notification.expiredProjects} Projects have expired
        </Typography>
      </NotificationCard>
      <NotificationCard
        name="INVOICES"
        iconSrc={NotificationInvoiceIcon}
        onNotificationClick={() =>
          navigate(INVOICES, { state: { notification: 2 } })
        }
      >
        <Typography color="grey.900" fontWeight="bold">
          {notification.reviewInvoices} Open Invoices to review
        </Typography>
      </NotificationCard>
    </Box>
  );
};

export default NotificationsList;
